import { federalReviewActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'
import { log } from '_services'

const initialState = {
    selectedMessage: undefined,
    loading: false,
    replyVisible: false
};

export const reducer = createReducer(initialState, {
    [federalReviewActions.setSelectedMessage]: (state, action) => {
        state.selectedMessage = action.payload.nono;
        state.replyVisible = false;
    },
    [federalReviewActions.markReadFailure]: (state, action) => {
        log.error('Error marking note as read. nono: ' + action.payload.nono + ' error: ' + action.payload.error);
    },
    [federalReviewActions.loadRequest]: (state, action) => {
        state.loading = true;
    },
    [federalReviewActions.loadSuccess]: (state, action) => {
        state.loading = false;
    },
    [federalReviewActions.loadFailure]: (state, action) => {
        state.loading = false;
        log.error('Error loading notes pending action. error: ' + action.payload.error);
    },
    [federalReviewActions.replySuccess]: (state, action) => {
        state.selectedMessage = undefined;
        state.replyVisible = false;
    },
    [federalReviewActions.replyFailure]: (state, action) => {
        log.error('Error replying mxno: ' + action.payload.mxno + ' error: ' + action.payload.error);
    },
    [federalReviewActions.toggleReply]: (state, action) => {
        state.replyVisible = !state.replyVisible;
    },
    [federalReviewActions.closeNotificationSuccess]: (state, action) => {
        state.selectedMessage = undefined;
    }


})


